export default __webpack_public_path__ + "static/media/261.c95411c1.jpg";